import * as Sentry from "@sentry/browser";

Sentry.init({
  dsn: document.currentScript.dataset.sentryDsn,
  environment: document.currentScript.dataset.sentryEnv,
});
